import PropTypes from 'prop-types';

export const BLOCK_EDITOR_PROPTYPES = {
  // eslint-disable-next-line react/forbid-prop-types
  contentBlock: PropTypes.object,
  onCancel: PropTypes.func,
  onSaveSuccessfully: PropTypes.func,
  title: PropTypes.string,
  partnerId: PropTypes.string,
};

export const BLOCK_EDITOR_DEFAULTS_PROPS_VALUE = {
  contentBlock: {
    id: '',
    partnerId: '',
    contentType: 'html',
    title: '',
    description: '',
    displayOrder: 0,
    content: '',
  },
  onCancel: () => null,
  onSaveSuccessfully: () => null,
  title: '',
  partnerId: '',
};

export * from './ActionButtons';
export * from './ContentBlockEditor';
